import React from "react";
import { Button, ButtonProps } from "antd";
import { DropdownChildButton } from "src/components/buttons/DropdownChildButton";

type PropsChildEntsButton = Omit<ButtonProps, "type"> & {
  isDropdownView: boolean;
};

export const ChildEntsButton: React.FC<PropsChildEntsButton> = ({
  isDropdownView,
  ...props
}) => {
  const buttonProps: ButtonProps = {
    ...props,
    type: isDropdownView ? "default" : "primary",
  };
  return isDropdownView ? (
    <DropdownChildButton {...buttonProps} />
  ) : (
    <Button {...buttonProps} />
  );
};
